'use client'

import { AppSetup } from '@ethena/shared-ui/src/components/AppSetup'
import { Route } from '@ethena/shared-ui/src/components/NavBar/NavBar'
import {
  CAREERS_URL,
  DAPP_URL,
  GITBOOK_URL,
  GOVERNANCE_URL,
  MIRROR_URL,
  NETWORK_URL,
} from '@ethena/shared-ui/src/constants/url'
import { wagmiAdapter } from '@ethena/shared-ui/src/constants/wagmiConfig'
import { useIdle } from '@ethena/shared-ui/src/hooks/useIdle'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { cookieToInitialState, WagmiProvider } from 'wagmi'

import { IS_GERMAN } from '@/constants'
import { REDEMPTION_PAGE } from '@/constants/redemption'
import useUserStore from '@/store/user-store'

import { LandingWrapper } from './landing-wrapper'

interface GlobalContainerProps {
  children: React.ReactNode
  cookies: string | null
}

export const routes = [
  { cutToMenuBreakpoint: 'md:block', route: '/', title: 'Home' },
  ...(IS_GERMAN
    ? [
        {
          cutToMenuBreakpoint: 'md:block',
          route: REDEMPTION_PAGE,
          title: 'Redemption',
        },
      ]
    : [
        { cutToMenuBreakpoint: 'lg:block', route: '/ecosystem', title: 'Ecosystem' },
        {
          cutToMenuBreakpoint: 'lg:block',
          route: NETWORK_URL,
          title: 'Network',
        },
        {
          cutToMenuBreakpoint: 'xl:block',
          route: DAPP_URL + '/dashboards/transparency',
          title: 'Transparency',
        },
        {
          cutToMenuBreakpoint: 'xl:block',
          route: GITBOOK_URL,
          title: 'Docs',
        },
        {
          cutToMenuBreakpoint: 'xl:block',
          route: '',
          routes: [
            { route: MIRROR_URL, title: 'Blog' },
            { route: GOVERNANCE_URL, title: 'Governance' },
            { route: CAREERS_URL, title: 'Careers' },
            { route: `${DAPP_URL}/leaderboard`, title: 'Leaderboard' },
          ],
          title: 'Community',
        },
      ]),
] as Route[]

export const GlobalContainer = ({ children, cookies }: GlobalContainerProps) => {
  const { setIsIdle } = useUserStore()
  const idle = useIdle(120_000)

  useEffect(() => {
    setIsIdle(idle)
  }, [idle, setIsIdle])

  const queryClient = new QueryClient()

  const initialState = cookieToInitialState(wagmiAdapter.wagmiConfig, cookies)

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig} initialState={initialState}>
      <QueryClientProvider client={queryClient}>
        <AppSetup>
          <LandingWrapper routes={routes}>{children}</LandingWrapper>
        </AppSetup>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
